/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 4/8/2015
 * Time: 3:48 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    //require regions fold
    var LE = require("app");
    var BaseDataManager = require("controllers/BaseDataManager");

    //collections
    var CannedCollection   = require("content-collections/CannedCollection");
    var HotKeysCollection = require("content-collections/HotKeysCollection");
    var SystemCollection = require("content-collections/SystemCollection");
    var SystemMessagingCollection = require("content-collections/SystemMessagingCollection");
    var SystemMessagingDefaultsCollection = require("content-collections/SystemMessagingDefaultsCollection");
    var SettingsCollection = require("collections/SettingsCollection");


    var ENTITY_ENUM = {
        CANNED:   CannedCollection.NAME,
        HOTKEYS:  HotKeysCollection.NAME,
        SYSTEM:   SystemCollection.NAME,
        SYSTEM_MESSAGING: SystemMessagingCollection.NAME,
        SYSTEM_MESSAGING_DEFAULTS: SystemMessagingDefaultsCollection.NAME,
        SITE_SETTINGS_LANGUAGE: "SiteSettingsLanguage",
    };

    var ContentDataManager = {};

    function moduleDefinition(LEContent, LE, Backbone, Marionette, $, _) {

        ContentDataManager = BaseDataManager.extend({
            ENTITY_ENUM: ENTITY_ENUM,
            initialize: function(options) {
                LEContent.logger.info("initializing", "ContentDataManager:initialize");
                this._initData(options);
                this._bindEvents();
            },

            getEntities: function() {
                return this._getEntities();
            },

            _initData: function(options) {
                BaseDataManager.prototype.initialize.call(this, options);

                this.addDataObj(ENTITY_ENUM.CANNED, new CannedCollection());
                this.addDataObj(ENTITY_ENUM.HOTKEYS, new HotKeysCollection());
                this.addDataObj(ENTITY_ENUM.SYSTEM, new SystemCollection());
                this.addDataObj(ENTITY_ENUM.SYSTEM_MESSAGING, new SystemMessagingCollection());
                this.addDataObj(ENTITY_ENUM.SYSTEM_MESSAGING_DEFAULTS, new SystemMessagingDefaultsCollection());
                this.addDataObj(ENTITY_ENUM.SITE_SETTINGS_LANGUAGE, new SettingsCollection([], {groups:SettingsCollection.SETTINGS_ENUM.SETTING_GROUP.languageManager, contextType: SettingsCollection.SETTINGS_ENUM.CONTEXT_TYPE.ACCOUNT, contextCascading: false}));


                var categoriesCollection = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getCategories);
                ENTITY_ENUM.CATEGORY = categoriesCollection.name;
                this.addDataObj(ENTITY_ENUM.CATEGORY, categoriesCollection);

                var skillsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getSkillsCollection);
                ENTITY_ENUM.SKILL = skillsCollection.name;
                this.addDataObj(ENTITY_ENUM.SKILL, skillsCollection);

            },

            _bindEvents: function() {
                this.listenTo(this.getData(ENTITY_ENUM.SYSTEM_MESSAGING), "fetch:success", this._syncMergedMessagingData);
                this.listenTo(this.getData(ENTITY_ENUM.SYSTEM_MESSAGING_DEFAULTS), "fetch:success", this._syncMergedMessagingData);
            },


            getArrayNamesByIds: function(entity, idsArray, nameAttribute) {
                var namesArray = [];
                var collection = this.getData(entity);
                var name = "";

                if (collection && idsArray) {
                    _.each(idsArray, function(id){
                        var model = collection.get(id);
                        if (!_.isEmpty(model)) {
                            var nameAttr = nameAttribute || "name";
                            name = model.get(nameAttr);
                            namesArray.push({"id": id, "name": name});
                        }
                    });
                }
                return namesArray;
            },

            //functions for paging in edit content:

            getItemIndexInfo: function (model,entity) {
                var result = {currentPageNumber: 0, totalPages: 1};
                var colin = this.getData(entity); //colin is a nice good and solid collection name please dont change it or risk my wrath
                var foundModel =  colin.findWhere({id: model.id});//cant do index of model when model is not really in the collection
                if (foundModel){
                    result.currentPageNumber = colin.indexOf(foundModel); //we keep here the indexing of js (first element is 0, view component will decide how to show it as 0 or 1)
                    result.totalPages        = colin.length;
                }

                return  result;
            },

            getItemIDByIndex: function (currModel,index,entity) {
                var colin = this.getData(entity); //colin is a nice good and solid collection name please dont change it or risk my wrath
                var model = colin.at(index);
                return  model.id;
            },
            getDefaultMessagingAutoMessagesModel: function(msgEventID) {
                var defaultsCollection = this.getSystemMessagingDefaultsCollection();
                return defaultsCollection.find(function(model){
                   return model.getEventId() == msgEventID;
                });
            },

            _getEntities: function() {
                return ENTITY_ENUM;
            }



         });
    }

    LE.module("LEContent", moduleDefinition);

    ContentDataManager.ENTITY_ENUM = ENTITY_ENUM;

    return ContentDataManager;

});
